const SCRIPT_ID = "axeptio-sdk"
const SCRIPT_URL = "https://static.axept.io/sdk.js"
const PROJECT_META_SELECTOR = 'meta[name="axeptio-client-id"]'
const OVERLAY_ID = "axeptio_overlay"

let axeptioLoading
let turboLifecycleRegistered = false

function configuredSettings() {
  const meta = document.querySelector(PROJECT_META_SELECTOR)
  if (!meta) return null

  return {
    clientId: meta.content,
    cookiesVersion: meta.dataset.cookiesVersion
  }
}

function removeCallback(callback) {
  const index = globalThis._axcb?.indexOf(callback)
  if (index >= 0) globalThis._axcb.splice(index, 1)
}

function preserveOverlay(event) {
  const overlay = document.getElementById(OVERLAY_ID)
  if (!overlay) return

  event.detail.newBody.querySelector(`#${OVERLAY_ID}`)?.remove()
  event.detail.newBody.append(overlay)
}

function configureSdk(sdk) {
  const cookiesVersion = configuredSettings()?.cookiesVersion
  if (cookiesVersion && sdk?.settings?.cookiesVersion !== cookiesVersion) {
    sdk?.setCookiesVersion?.(cookiesVersion)
  }

  return sdk
}

function synchronizeCookiesVersion() {
  return loadAxeptio().then(configureSdk).catch(() => null)
}

function registerTurboLifecycle() {
  if (turboLifecycleRegistered) return

  document.addEventListener("turbo:before-render", preserveOverlay)
  document.addEventListener("turbo:load", synchronizeCookiesVersion)
  turboLifecycleRegistered = true
}

export function loadAxeptio() {
  if (globalThis.axeptioSDK) return Promise.resolve(globalThis.axeptioSDK)
  if (axeptioLoading) return axeptioLoading

  const settings = configuredSettings()
  if (!settings?.clientId) return Promise.resolve(null)

  globalThis.axeptioSettings = {
    ...globalThis.axeptioSettings,
    ...settings,
    triggerGTMEvents: false
  }
  globalThis._axcb ||= []

  axeptioLoading = new Promise((resolve, reject) => {
    const ready = sdk => resolve(sdk)
    const existingScript = document.getElementById(SCRIPT_ID)
    const script = existingScript || document.createElement("script")

    globalThis._axcb.push(ready)

    if (existingScript) return

    script.id = SCRIPT_ID
    script.async = true
    script.src = SCRIPT_URL
    script.addEventListener("error", () => {
      removeCallback(ready)
      script.remove()
      axeptioLoading = null
      reject(new Error("Unable to load Axeptio"))
    }, { once: true })
    document.head.append(script)
  })

  return axeptioLoading
}

export function initializeAxeptio() {
  registerTurboLifecycle()
  synchronizeCookiesVersion()
}

export function openAxeptioPreferences() {
  return loadAxeptio().then(configureSdk).then(sdk => sdk?.openCookies())
}
